export default __webpack_public_path__ + "static/media/phase1-bg.3250e8db.svg";